import { chunk } from '@seekingalpha/samw-utils';

import { apiV3 } from 'Services/api/apiV3';
import { getUserCookieKey } from 'Services/api/utils';

type ResponseT = Promise<{
  data: ReadonlyArray<any>;
}>;

const CHUNK_LENGTH = 500;

export const getEmailNotifications = async function (
  tags: ReadonlyArray<string | number>,
): Promise<ResponseT> {
  const chunks = chunk(tags, CHUNK_LENGTH);

  const response = await Promise.all(
    chunks.map((currentChunk) => {
      return apiV3.get(`account/${getUserCookieKey()}/subscriptions`, {
        tags: currentChunk.join(','),
      });
    }),
  );

  return response.reduce(
    (acc, currentChunk) => {
      return {
        data: acc.data.concat(currentChunk.data),
      };
    },
    { data: [] },
  );
};
